<div class="p-fluid" *ngIf="insurableObject">
  <div class="field">
    <label class="mb-3 block font-medium">Bild ändern</label>

    <div class="avatar-wrapper mx-auto mb-5">
      <img
        *ngIf="!croppedImage"
        insurableObjectImage
        [insurableObject]="insurableObject"
        class="w-full h-full border-circle object-cover"
        loading="lazy" />
      <img
        *ngIf="croppedImage"
        [src]="croppedImage || insurableObject?.imageUrl"
        alt="Insurable Object"
        class="avatar-image"
        loading="lazy" />

      <label for="upload" class="upload-button" pRipple>
        <i class="pi pi-upload upload-icon text-white"></i>
      </label>

      <input
        id="upload"
        type="file"
        hidden
        accept="image/*"
        (change)="onUploadHandler($event)" />
    </div>

    <p-dialog
      header="Bild anpassen"
      [(visible)]="showImageCropperDialog"
      [modal]="true"
      [style]="{width: '50rem', height: '50rem'}"
      (onHide)="resetFileInput()"
    >
      <ng-template pTemplate="content">
        <div class="flex align-items-center h-full w-full">
          <image-cropper
            *ngIf="imageChangedEvent"
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="1 / 1"
            format="png"
            (imageCropped)="imageCropped($event)">
          </image-cropper>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button type="button" pButton label="Übernehmen" icon="pi pi-check" (click)="uploadCroppedImage()"></button>
      </ng-template>
    </p-dialog>
  </div>
</div>
